import { Icon } from './Icon'

/**
 * "Are you sure?", asked in the row it is about.
 *
 * Every dangerous act in this product asks twice, and until now every one of
 * them spelled the asking out again: a `.pubs__confirm` box, a sentence, a
 * `.pubs__actions` row, a danger button and a ghost one — written by hand in
 * eight files. Eight copies of a pattern is eight chances for one of them to
 * lose the sentence, or to put the safe answer where the dangerous one was,
 * and two of them had no second question at all: removing somebody from a
 * workspace and turning off two-step sign-in both happened on one press.
 *
 * INLINE, and that is the pattern rather than an accident. A modal draws
 * itself over the row it is asking about, so the thing you are deciding on is
 * the one thing you cannot see; this opens under it, says what the act does in
 * a sentence, and puts the two answers in the same order every time — the act
 * first, because it is what was pressed, and the way out beside it.
 */
export function Confirm({
  says,
  does,
  cancel = 'Cancel',
  busy = false,
  onYes,
  onNo,
  ...rest
}: {
  /** What the act does, said in the words its consequence has. */
  says: string
  /** The dangerous answer, as a verb: "Remove them", "Hand it over". */
  does: string
  /** The safe answer. Its default is fine; a better one names what is kept. */
  cancel?: string
  busy?: boolean
  onYes: () => void
  onNo: () => void
} & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className="pubs__confirm" {...rest}>
      <p className="field__note">{says}</p>
      <div className="pubs__actions">
        <button
          className="btn btn--danger btn--sm"
          /* One name for the dangerous answer, everywhere it is asked: a gate
             that drives a confirmation should not have to know which screen
             drew it. */
          data-confirm-yes
          disabled={busy}
          onClick={onYes}
        >
          {busy ? <Icon name="spinner" size={13} /> : null}
          {does}
        </button>
        <button className="btn btn--ghost btn--sm" data-confirm-no disabled={busy} onClick={onNo}>
          {cancel}
        </button>
      </div>
    </div>
  )
}
